import { useCallback, useEffect, useState } from 'react';
import { useAuthenticatedAPI } from '../../../state';
import { useWizardParams } from '../selectors';
export var COPY_VOLUME_API = '/api/volume/{dest}/{type}';
export var CLEAR_VOLUME_API = '/api/volume/{queueId}/{type}';
export var QUEUE_LOCATIONS_API = '/api/queue/{id}/locations';
export var QUEUE_HOURS_MISMATCH_API = '/api/queue/{id}/hoursMismatch';
export var useCopyVolumeAPI = function (type) {
    var dest = useWizardParams().queueId;
    var _a = useAuthenticatedAPI(COPY_VOLUME_API, { dest: dest, type: type }, 'POST'), data = _a[0], fetchData = _a[1], clearData = _a[2];
    var fetchDataWrapper = useCallback(function (source) {
        if (dest) {
            fetchData(undefined, { source: source });
        }
    }, [fetchData, dest]);
    return [data, fetchDataWrapper, clearData];
};
export var useClearVolumeAPI = function (type) {
    var queueId = useWizardParams().queueId;
    var _a = useAuthenticatedAPI(CLEAR_VOLUME_API, { queueId: queueId, type: type }, 'DELETE'), data = _a[0], fetchData = _a[1], clearData = _a[2];
    var fetchDataWrapper = useCallback(function () {
        if (queueId) {
            fetchData();
        }
    }, [fetchData, queueId]);
    return [data, fetchDataWrapper, clearData];
};
export var useQueueLocationSelectionAPI = function () {
    var id = useWizardParams().queueId;
    var _a = useAuthenticatedAPI(QUEUE_LOCATIONS_API, { id: id }, 'GET'), data = _a[0], fetchData = _a[1], clearData = _a[2];
    var fetchDataWrapper = useCallback(function () {
        if (id) {
            fetchData();
        }
    }, [fetchData, id]);
    return [data, fetchDataWrapper, clearData];
};
export var useSaveQueueLocationSelectionAPI = function () {
    var id = useWizardParams().queueId;
    var _a = useAuthenticatedAPI(QUEUE_LOCATIONS_API, { id: id }, 'PUT'), data = _a[0], fetchData = _a[1], clearData = _a[2];
    var fetchDataWrapper = useCallback(function (payload) {
        if (id) {
            fetchData(payload);
        }
    }, [fetchData, id]);
    return [data, fetchDataWrapper, clearData];
};
export var useQueueHoursMismatchAPI = function (cacheKey) {
    var id = useWizardParams().queueId;
    var _a = useAuthenticatedAPI(QUEUE_HOURS_MISMATCH_API, { id: id }, 'GET', { key: cacheKey }), data = _a[0], fetchData = _a[1], clearData = _a[2];
    var fetchMismatch = useCallback(function (timezone) {
        if (id) {
            fetchData(undefined, timezone ? { timezone: timezone } : undefined);
        }
    }, [fetchData, id]);
    return [data, fetchMismatch, clearData];
};
export var useHoursMismatchDialog = function (cacheKey) {
    var _a = useQueueHoursMismatchAPI(cacheKey), mismatchData = _a[0], fetchMismatch = _a[1], clearMismatch = _a[2];
    var _b = useState(false), mismatchDialogOpen = _b[0], setMismatchDialogOpen = _b[1];
    var _c = useState([]), mismatchedLocations = _c[0], setMismatchedLocations = _c[1];
    useEffect(function () {
        if (!mismatchData.data)
            return;
        var names = mismatchData.data.mismatchedLocations;
        clearMismatch();
        if (names.length > 0) {
            setMismatchedLocations(names);
            setMismatchDialogOpen(true);
        }
    }, [clearMismatch, mismatchData.data]);
    return { mismatchDialogOpen: mismatchDialogOpen, mismatchedLocations: mismatchedLocations, setMismatchDialogOpen: setMismatchDialogOpen, fetchMismatch: fetchMismatch };
};
